import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        {/* Header */}
        <header className="privacy-header">
          <div className="header-content">
            <div className="logo-container">
              <img src="/favicon.ico" alt="TabTrips" className="logo" />
              <div className="brand-text">
                <h1 className="brand-title">TabTrips</h1>
                <p className="brand-subtitle">Privacy Policy</p>
              </div>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="privacy-content">
          <div className="content-wrapper">
            <h1 className="page-title">Privacy Policy</h1>
            <p className="last-updated">Last updated: January 2024</p>

            <section className="policy-section">
              <h2>1. Information We Collect</h2>
              <p>We collect information you provide directly to us, such as when you create an account, make a booking, or contact us for support. This may include:</p>
              <ul>
                <li>Name, email address, and phone number</li>
                <li>Property information and details</li>
                <li>Booking and reservation data</li>
                <li>Payment information (processed securely)</li>
                <li>Communication preferences</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide and maintain our services</li>
                <li>Process bookings and reservations</li>
                <li>Send important updates and notifications</li>
                <li>Provide customer support</li>
                <li>Improve our platform and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>3. Information Sharing</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties except in the following circumstances:</p>
              <ul>
                <li>With your explicit consent</li>
                <li>To comply with legal requirements</li>
                <li>To protect our rights and safety</li>
                <li>With trusted service providers who assist in operating our platform</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Data Security</h2>
              <p>We implement appropriate security measures to protect your personal information:</p>
              <ul>
                <li>Encryption of sensitive data</li>
                <li>Secure servers and infrastructure</li>
                <li>Regular security audits</li>
                <li>Access controls and authentication</li>
                <li>Employee training on data protection</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
                <li>Port your data to another service</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>6. Cookies and Tracking</h2>
              <p>We use cookies and similar technologies to:</p>
              <ul>
                <li>Remember your preferences</li>
                <li>Analyze website usage</li>
                <li>Improve user experience</li>
                <li>Provide personalized content</li>
              </ul>
              <p>You can control cookie settings through your browser preferences.</p>
            </section>

            <section className="policy-section">
              <h2>7. Third-Party Services</h2>
              <p>Our platform may integrate with third-party services for:</p>
              <ul>
                <li>Payment processing</li>
                <li>Analytics and tracking</li>
                <li>Customer support tools</li>
                <li>Marketing services</li>
              </ul>
              <p>These services have their own privacy policies.</p>
            </section>

            <section className="policy-section">
              <h2>8. Data Retention</h2>
              <p>We retain your personal information for as long as necessary to:</p>
              <ul>
                <li>Provide our services</li>
                <li>Comply with legal obligations</li>
                <li>Resolve disputes</li>
                <li>Enforce our agreements</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>9. International Transfers</h2>
              <p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your data.</p>
            </section>

            <section className="policy-section">
              <h2>10. Children's Privacy</h2>
              <p>Our services are not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>
            </section>

            <section className="policy-section">
              <h2>11. Changes to This Policy</h2>
              <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.</p>
            </section>

            <section className="policy-section">
              <h2>12. Contact Us</h2>
              <p>If you have any questions about this privacy policy, please contact us:</p>
              <div className="contact-info">
                <p><strong>Email:</strong> privacy@tabtrips.com</p>
                <p><strong>Phone:</strong> +91 7082828181</p>
                <p><strong>Address:</strong> TabTrips Headquarters, India</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 